import { Chart } from "chart.js";
import { getChartTheme } from "./theme";

// Canvas does not inherit CSS colors. Apply the document palette to every
// chart, including legacy analytics that provide their own options.
export const chartThemePlugin = {
  id: "portalTheme",
  beforeUpdate(chart) {
    const palette = getChartTheme(document.documentElement.dataset.theme || "light");
    if (chart.canvas) {
      chart.canvas.setAttribute("role", "img");
      if (!chart.canvas.hasAttribute("aria-label") || chart.canvas.dataset.portalChartLabel === "true") {
        const title = chart.options.plugins?.title?.text;
        const labels = chart.data?.labels?.slice(0, 12).join(", ");
        chart.canvas.setAttribute("aria-label", [title || `${chart.config?.type || "Data"} chart`, labels].filter(Boolean).join(": "));
        chart.canvas.dataset.portalChartLabel = "true";
      }
    }
    chart.options.color = palette.text;
    if (chart.options.plugins?.legend?.labels) {
      chart.options.plugins.legend.labels.color = palette.legend || palette.text;
    }
    if (chart.options.plugins?.title) chart.options.plugins.title.color = palette.text;
    Object.values(chart.options.scales || {}).forEach((scale) => {
      if (scale.ticks) scale.ticks.color = palette.text;
      if (scale.title) scale.title.color = palette.text;
      if (scale.grid) scale.grid.color = palette.grid;
      if (scale.border) scale.border.color = palette.grid;
      if (scale.angleLines) scale.angleLines.color = palette.grid;
      if (scale.pointLabels) scale.pointLabels.color = palette.text;
    });
  },
};

export function watchChartTheme() {
  Chart.register(chartThemePlugin);
  const update = () => Object.values(Chart.instances).forEach((chart) => chart.update("none"));
  window.addEventListener("app-theme-change", update);
  return () => window.removeEventListener("app-theme-change", update);
}
